module.exports = __webpack_public_path__ + "img/nostromo 1.424a60cf.jpeg";